import { getOptionVanillaLegMetadata } from './factories';

export const getOptionVanillaLegSolvingFor = getOptionVanillaLegMetadata('solvingFor');

export const getOptionVanillaLegSolved = getOptionVanillaLegMetadata('solved');
